import { render, staticRenderFns } from "./documents-tab.vue?vue&type=template&id=0928008a&scoped=true"
import script from "./documents-tab.vue?vue&type=script&lang=js"
export * from "./documents-tab.vue?vue&type=script&lang=js"
import style0 from "./documents-tab.vue?vue&type=style&index=0&id=0928008a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0928008a",
  null
  
)

export default component.exports